export default "__VITE_ASSET__BEVG7HRM__"